import * as React from "react";
const SvgFiRrSquareRoot = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-square-root_svg__a)">
      <path
        fill="#062147"
        d="M16.04 4a3.01 3.01 0 0 0-2.89 2.2L9.1 20.768A1.68 1.68 0 0 1 7.5 22a1.75 1.75 0 0 1-1.622-1.159l-2.793-7.68a3.46 3.46 0 0 0-2.312-2.189 1 1 0 0 1 .471-1.944 5.43 5.43 0 0 1 3.721 3.45l2.474 6.8 3.784-13.616A5.016 5.016 0 0 1 16.04 2H23a1 1 0 1 1 0 2zm7.56 8.2a1 1 0 0 0-1.4.2L20 15.333 17.8 12.4a1 1 0 1 0-1.6 1.2l2.55 3.4-2.55 3.4a1 1 0 0 0 1.6 1.2l2.2-2.933 2.2 2.933a1 1 0 1 0 1.6-1.2L21.25 17l2.55-3.4a1 1 0 0 0-.2-1.4"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-square-root_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSquareRoot;
